<template>
    <main id="mainCtrl" v-cloak>
        <header class="header-filters">
            <div class="header-filters__group">
            <!--TODO v-select-period посылает событие 2 раза -->
                <date-range-picker ref="datepicker"
                                   @selected="setCreatePeriodFilter"
                />
                <div></div>
            </div>
        </header>

        <v-table id="table"
                 request-uri="calls/getList"
                 pagesize="50"
                 ref="table"
                 :default-filter="{}"
                 @clear-table-filter="clearPlaceholder"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th v-if="isMulti" name="clinicCity" width="50">
                        Город
                    </v-th>
                    <v-th name="callkeeper_id" width="70">
                        №
                    </v-th>
                    <v-th name="orderDate" sort="orderDate" width="60">
                        Создан
                    </v-th>
                    <v-th name="filelength" sort="filelength" width="50" tooltip="Длительность">
                        Длит
                    </v-th>
                    <v-th name="clinicName" minwidth="150">
                        Клиника
                    </v-th>
                    <v-th name="phone" sort="phone" width="120">
                        Тел пациента
                    </v-th>
                    <v-th name="filename" minwidth="270">
                        Запись разговора
                    </v-th>
                    <v-th name="comment" width="250">
                        Комментарий
                    </v-th>
                    <v-th name="callkeeper_service_type" sort="callkeeper_service_type" width="150">
                        Тип звонка
                    </v-th>
                    <v-th name="status" width="50">
                        Статус
                    </v-th>
                    <v-th name="status_description" width="200">
                        Описание статуса
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th v-if="isMulti" name="clinicCity" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options='[
                                        {
                                            value: "",
                                            text: "\u00a0"
                                        },
                                        ...cityOptions
                                  ]'/>
                    </v-th>
                    <v-th name="callkeeper_id" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="orderDate" v-slot="{filter}">
                        <date-piker
                            :format="'YYYY-MM-DD'"
                            v-model="filter.value"
                            ref="singleDate"
                            @change="clearDateRangePicker"
                        />
                    </v-th>
                    <v-th name="filelength" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "0",
                                    text: "0 сек"
                                },
                                {
                                    value: "< 45",
                                    text: "<45 сек"
                                },
                                {
                                    value: ">= 45",
                                    text: "≥45 сек"
                                },
                                {
                                    value: ">= 300",
                                    text: "≥5 мин"
                                },
                                {
                                    value: ">= 600",
                                    text: "≥10 мин"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="clinicName" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...clinics
                            ]'
                        />
                    </v-th>
                    <v-th name="phone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="filename"  v-slot="{filter}">
                        <input disabled>
                    </v-th>
                    <v-th name="comment" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="callkeeper_service_type" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "calltracking",
                                    text: "Статический коллтрекинг"
                                },
                                {
                                    value: "callback",
                                    text: "Обратный звонок"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="status" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "200/200",
                                    text: "Успешный"
                                },
                                {
                                    value: "STATUS_FAIL",
                                    text: "Не успешный"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="status_description" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...descriptionStatuses
                            ]'
                        />
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{item, index}">
                <v-tr style="cursor: default">
                    <v-td v-if="isMulti" name="clinicCity">
                        <template v-for="(city, i) in item.clinicCities.split(',')">
                            <template v-if="cityOptions.find(el => el.value === city)">
                                <span>{{ cityOptions.find(el => el.value === city).textAbbr }}</span>
                                <br v-if="(i + 1) < item.clinicNames.split('∴').length">
                            </template>
                        </template>
                    </v-td>
                    <v-td name="callkeeper_id">
                        {{ item.callkeeper_id }}
                    </v-td>
                    <v-td name="orderDate">
                        <div>{{ item.orderDate | formatDateShort }}</div>
                        <div>{{ item.orderTime | formatTime }}</div>
                    </v-td>
                    <v-td name="filelength">
                        {{ item.filelength | formatDuration }}
                    </v-td>
                    <v-td name="clinicName">
                        <template v-for="(clinicName, i) in item.clinicNames.split('∴')">
                            <span>{{ clinicName }}</span>
                            <br v-if="(i + 1) < item.clinicNames.split('∴').length">
                        </template>
                    </v-td>
                    <v-td name="phone">
                        {{ item.phone }}
                    </v-td>
                    <v-td name="filename" align="center">
                        <audio preload="none" v-if="item.audioIsPlayable" controls :src="item.callkeeper_file_url"></audio>
                        <span v-else> - </span>
                    </v-td>
                    <v-td name="comment">
                        <textarea v-model="item.comment"
                                  @blur="e => saveComment(item)"
                                  style="font-size: 13px; height: 40px;"/>
                    </v-td>
                    <v-td name="callkeeper_service_type">
                        {{ item.callkeeper_service_type }}
                    </v-td>
                    <v-td name="status" align="center">
                        <i v-if="item.status.status" :style="{color: item.status.color}" class="fa-solid fa-check"></i>
                        <i v-else :style="{color: item.status.color}" class="fa-solid fa-ban"></i>
                    </v-td>
                    <v-td name="status_description">
                        {{ item.status_description }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
export default {
    props: {
        cityOptions: { type: Array, required: true },
        descriptionStatuses: { type: Array, required: true },
        clinics: { type: Array, required: true },
        isMulti: { type: Boolean, required: true },
    },

    methods: {
        setCreatePeriodFilter(data) {
            if (this.isTableLoaded()) {
                if (data) {
                    this.$refs.table.$data.filter.createdPeriod = data;
                    if (this.$refs.singleDate) {
                        this.$refs.singleDate.$refs.popup.clear();
                    }
                } else {
                    delete this.$refs.table.$data.filter.createdPeriod;
                }
                this.$refs.table.update();
            }
        },
        isTableLoaded() {
            return this.$refs?.table !== undefined;
        },
        clearDateRangePicker() {
            if (this.$refs.singleDate.date && this.$refs.datepicker.end) {
                delete this.$refs.datepicker.clearRange();
            }
        },
        clearPlaceholder() {
            this.$refs.datepicker.clearRange()
        },
        handleAudioListener(e) {
            let audios = document.getElementsByTagName('audio');

            for(let i = 0; i < audios.length; i++) {
                if(audios[i] !== e.target) {
                    audios[i].pause();
                }
            }
        },
        saveComment(item) {
            this.axios.post('calls/saveComment/' + item.callkeeper_id, {
                comment: item.comment
            });
        }
    },
    mounted: function () {
        document.addEventListener('play', this.handleAudioListener, true);
    },
    destroyed: function () {
        document.removeEventListener('play', this.handleAudioListener, true);
    }
}
</script>

<style scoped lang="scss">
.header-filters {
    display: flex;
    justify-content: space-between;
    &__group {
        height: 34px;
    }
}
audio {
    height: 40px;
    width: 100%;
}
</style>
